import {onHistoryChange} from 'core/next/helpers';
import {TBeforePopStateCallback} from 'core/types';
import {useEffect} from 'react';

export const useHistoryListener = (callback: TBeforePopStateCallback) => {
    useEffect(() => {
        const disposer = onHistoryChange(callback);

        return () => disposer(callback);
    }, [callback]);
};
